




















































































































































import Vue from 'vue'
import { Salutation } from '@/model/addresses/Salutation'
import { Title } from '@/model/addresses/Title'
import { UiLanguageList } from '@/types'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'
import { AddressEmployeeDataPayload } from '@/types/payload'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { EmployeeFunction } from '@/model/addresses/EmployeeFunction'
import { ContactListItem } from '@/types/service-response'

interface ComponentData {
  selectedSalutation: number | undefined
  selectedTitle: number | undefined
  firstName: string
  position: number | undefined
  supervisor: string
  assistant: string
  nickname: string
  selectedLanguage: number | undefined
  active: boolean
  name: string
  department: string
  office: string
  job: string
  dateOfBirth: string | null
  genAddress: string | null
  businessPhone: string
  privatePhone: string
  businessMobile: string
  privateMobile: string
  businessMail: string
  privateMail: string
  dateFormatted: string
  dateRules: any[]
  contactList: ContactListItem[]
}

export default Vue.extend({
  name: 'AddressEmployeeDialog',

  components: {

  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    isEdit: Boolean,
    addressId: Number,
    title: String,
    salutationList: {
      type: Array as () => Array<Salutation>
    },
    titleList: {
      type: Array as () => Array<Title>
    },
    functionList: {
      type: Array as () => Array<EmployeeFunction>
    },
    editData: {
      type: Object as () => AddressEmployee
    },
    loading: Boolean
  },

  data (): ComponentData {
    return {
      selectedSalutation: undefined,
      selectedTitle: undefined,
      firstName: '',
      position: undefined,
      supervisor: '',
      assistant: '',
      nickname: '',
      selectedLanguage: undefined,
      active: true,
      name: '',
      department: '',
      office: '',
      job: '',
      dateOfBirth: null,
      genAddress: '',
      businessPhone: '',
      privatePhone: '',
      businessMobile: '',
      privateMobile: '',
      businessMail: '',
      privateMail: '',
      dateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string) => {
          return value.length >= 1 && value.length !== 10 ? 'Falsche Datum.' : true
        }
      ],
      contactList: []
    }
  },

  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    dateDateOfBirthFormatted (): string {
      if(this.dateOfBirth) {
        const date: Date = new Date(this.dateOfBirth)
        return moment(date).format('DD.MM.YYYY')
      } else {
        return ''
      }
    },
  },

  watch: {
    show (newVal: boolean): void {
      if(newVal) {
        //this.fetchContactList()
        this.setData()
        if(this.isEdit) {
          setTimeout(() => {
            const focusedField: any = this.$refs['focusedField']
            if (focusedField) {
              focusedField.focus()
            }
          }, 0)
        }
      }
    },

    dateFormatted (newVal: string): void {
      if(newVal.length > 0) {
        this.dateOfBirth = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.dateOfBirth = null
      }
    }
  },

  methods: {
    /*getContactIcon (item: string | null): string {
      if(item) {
        switch (item) {
          case '001':
            return 'phone'
          case '002':
            return 'fax'
          case '003':
            return 'smartphone'
          case '004':
            return 'email'
          case '005':
            return 'mdi-web'
          case '006':
            return 'phone'
          case '007':
            return 'smartphone'
          case '008':
            return 'email'
          default:
            return ''
        }
      } else {
        return ''
      }
    },*/

    onDateChange (date: string): void {
      this.dateFormatted = moment(date).format('DD.MM.YYYY')
    },

    setData (): void {
      if(this.editData) {
        this.selectedSalutation = this.editData.salutation
        this.selectedTitle = this.editData.title
        this.firstName = this.editData.firstName
        this.position = this.editData.position
        this.supervisor = this.editData.supervisor
        this.assistant = this.editData.assistant
        this.nickname = this.editData.nickname
        this.selectedLanguage = this.editData.language ? this.editData.language : this.selectedLanguageId,
        this.active = this.editData.active
        this.name = this.editData.name
        this.department = this.editData.department
        this.office = this.editData.office
        this.job = this.editData.job
        this.dateOfBirth = this.editData.dateOfBirth ? moment(this.editData.dateOfBirth, 'DD.MM.YYYY').format('YYYY-MM-DD') : null
        this.dateFormatted = this.editData.dateOfBirth ? moment(this.editData.dateOfBirth , 'DD.MM.YYYY').format('DD.MM.YYYY') : ''
        this.genAddress = this.editData.genAddress
        this.businessPhone = this.editData.businessPhone
        this.privatePhone = this.editData.privatePhone
        this.businessMobile = this.editData.businessMobile
        this.privateMobile = this.editData.privateMobile
        this.businessMail = this.editData.businessMail
        this.privateMail = this.editData.privateMail
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {

        /*const privatePhonePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '006')
        const businessPhonePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '001')
        const privateMobilePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '007')
        const businessMobilePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '003')
        const privateMailPayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '008')
        const businessMailPayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '004')
        //const webPagePayload: ContactListItem | undefined = this.contactList.find((item: ContactListItem) => item.TelefonArtCode === '005')*/

        const payload: AddressEmployeeDataPayload = {
          id: this.editData ? this.editData.id : undefined,
          address: this.editData ? this.editData.address : this.addressId,
          privatAddress: this.editData ? this.editData.privatAddress : null,
          name: this.name,
          firstName: this.firstName,
          language: this.selectedLanguage ? this.selectedLanguage : this.selectedLanguageId,
          title: this.selectedTitle ? this.selectedTitle : null,
          salutation: this.selectedSalutation ? this.selectedSalutation : null,
          genAddress: this.genAddress,
          genSalutation: this.editData ? this.editData.genSalutation : '',
          addressLine: this.editData ? this.editData.addressLine : '',
          description: this.editData ? this.editData.description : '',
          addition: this.editData ? this.editData.addition : '',
          idMarker: this.editData ? this.editData.idMarker : undefined,
          mdt: this.editData ? this.editData.mdt : undefined,
          department: this.department,
          supervisor: this.supervisor,
          office: this.office,
          assistant: this.assistant,
          job: this.job,
          nickname: this.nickname,
          partner: this.editData ? this.editData.partner : '',
          dateOfBirth: this.dateOfBirth ? moment(this.dateOfBirth, 'YYYY-MM-DD').format('DD.MM.YYYY').toString() : '',
          anniversary: this.editData ? this.editData.anniversary : '',
          children: this.editData ? this.editData.children : '',
          active: this.active,
          financeRelevance: this.editData ? this.editData.financeRelevance : '',
          position: this.position,
          businessPhone: this.businessPhone,
          privatePhone: this.privatePhone,
          businessMobile: this.businessMobile,
          privateMobile: this.privateMobile,
          businessMail: this.businessMail,
          privateMail: this.privateMail



          /*businessPhone: businessPhonePayload && businessPhonePayload.Nummer ? businessPhonePayload.Nummer : '',
          privatePhone: privatePhonePayload && privatePhonePayload.Nummer ? privatePhonePayload.Nummer : '',
          businessMobile: businessMobilePayload && businessMobilePayload.Nummer ? businessMobilePayload.Nummer : '',
          privateMobile: privateMobilePayload && privateMobilePayload.Nummer ? privateMobilePayload.Nummer : '',
          privateMail: privateMailPayload && privateMailPayload.Nummer ? privateMailPayload.Nummer : '',
          businessMail: businessMailPayload && businessMailPayload.Nummer ? businessMailPayload.Nummer : '',
          //webPage: webPagePayload && webPagePayload.Nummer ? webPagePayload.Nummer : '',*/
        }
        this.$emit('save', payload)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    /*async fetchContactList (): Promise<void> {
      const response: GetContactListResponse = await this.$store.dispatch(FETCH_EMPLOYEE_CONTACT_LIST, this.editData.id)
      if (!response.IsError && response.Data) {
        this.contactList = response.Data
      }
    }*/
  },

  created () {

  }

})
